import "./LoadingPage.scss";
import { LinearProgress } from "@mui/material";
import { IyilestirIcons } from "../../../__product__/assets/icons/IyilestirIcons";
const LoadingPage = () => {
  return (
    <div className={"loading-root"}>
      <div className={"loading-logo"}>{IyilestirIcons.logo}</div>
      <LinearProgress className={"loading-bar"} />
    </div>
  );
};
export default LoadingPage;
